import { render, staticRenderFns } from "./VideoCatalog.vue?vue&type=template&id=51896d90&scoped=true&"
import script from "./VideoCatalog.vue?vue&type=script&lang=js&"
export * from "./VideoCatalog.vue?vue&type=script&lang=js&"
import style0 from "./VideoCatalog.vue?vue&type=style&index=0&id=51896d90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51896d90",
  null
  
)

export default component.exports